/* eslint max-len: ['error', { 'code': 200, 'tabWidth': 4 }] */
/* global M, store, __MENU_PANELS__, __PRETTY_USER_NAME__ */

'use strict';

import {
    DISPLAY_WIDTHS,
    xmlescape,
} from './common';

$(document).ready(function() {
    if(!$('.sidenav').length)
        return;
    try {
        $('.sidenav').sidenav({
            edge: 'right',
            onOpenStart: function() {
                $(this.el).trigger('sidenav-toggle');
            },
            onCloseStart: function() {
                $(this.el).trigger('sidenav-toggle');
            },
        }).on('sidenav-toggle', function() {
            const $this = $(this);
            const sidenav = M.Sidenav.getInstance($this);
            $this.toggleClass('active', sidenav.isOpen);
        });
    } catch(e) { /**/ }
});

$(function() {
    const menutoggle = $('#menu-panels-toggle');
    if(menutoggle.length) {
        menutoggle.on('click', function(evt) {
            evt.preventDefault();
            evt.stopPropagation();

            const span = $('#menu-panels-toggle').find('span');
            const cmd = (span.is('.glyphicon-collapse-up')) ? 'hide' : 'show';
            span.toggleClass('glyphicon-collapse-up').toggleClass('glyphicon-collapse-down');

            $('#menu-panels').find('.collapse').each(function() {
                const panel = $(this);
                const visible = panel.is('.in');
                if(((cmd == 'show') && !visible) || ((cmd == 'hide') && visible))
                    panel.collapse(cmd);
            });
        });

        try {
            if(store.enabled) {
                const panels = store.get('menu-panels-toggle');
                if(panels && (typeof (panels) == 'object')) {
                    for(const id in panels) {
                        $('#' + id).toggleClass('in', !!panels[id]);
                    }
                }
            }
        } catch(err) { /**/ }

        $('#menu-panels').find('.collapse').on('shown.bs.collapse hidden.bs.collapse', function() {
            try {
                if(store.enabled) {
                    let panels = store.get('menu-panels-toggle');
                    if(!panels || (typeof (panels) != 'object')) {
                        panels = {};
                    }
                    $('#menu-panels').find('.collapse').each(function() {
                        const panel = $(this);
                        panels[panel.attr('id')] = panel.is('.in');
                    });
                    store.set('menu-panels-toggle', panels);
                }
            } catch(err) { /**/ }
        });
    }
    $('.menu-panels-search-lbl').click(function(e) {
        const text = $('#menu-panels-search').val().toLowerCase().trim();
        let firstItemSearch = null;
        let firstItemSearchState = true;
        $('#menu-panels .bg-info:not(.utente)').find('.menu-item').each(function() {
            const item = $(this);
            const li = item.parent();
            if(li.is('#menu-item-exit'))
                return;
            const found = (item.text().toLowerCase().indexOf(text) >= 0);
            li.toggleClass('hidden', !found);
            // get first found element
            if(found && firstItemSearchState) {
                firstItemSearch = item;
                firstItemSearchState = false;
            }
        });
        if(firstItemSearch && text.length > 0) {
            window.location.href = window.location.origin + firstItemSearch.attr('href');
        }
    });
    if($('#menu-panels').length && $.safeWindowOnLoad) {
        $.safeWindowOnLoad(function() {
            if(DISPLAY_WIDTHS.user > DISPLAY_WIDTHS.xl) {
                $('#menu-panels .bg-info:not(.utente)').find('.menu-item:not(.parent-menu-item)').each(function() {
                    const Menu_fatture = $('#menu-panel-Menu-fatture').find('.navbar-nav:not(#menu-panels)').children('li');
                    const cntGroup = 7;
                    const divsArr = Menu_fatture.get();
                    for(let i = 0; i < Menu_fatture.length; i += cntGroup) {
                        $(divsArr.slice(i, i + cntGroup)).wrapAll('<ul class="wrap_Menu-fatture"></ul>');
                    }
                });
            }
        });
    }

    const menusearch = $('#menu-panels-search');
    if(menusearch.length) {
        menusearch.on('keyup input change', function(e) {
            const text = $('#menu-panels-search').val().toLowerCase().trim();
            let firstItemSearch = null;
            let firstItemSearchState = true;
            $('#menu-panels .bg-info:not(.utente)').find('.menu-item').each(function() {
                const item = $(this);
                const li = item.parent();
                if(li.is('#menu-item-exit'))
                    return;

                const found = (item.text().toLowerCase().indexOf(text) >= 0);
                li.toggleClass('hidden', !found);
                // get first found element
                if(found && firstItemSearchState) {
                    firstItemSearch = item;
                    firstItemSearchState = false;
                }
            });
            // if key code is Enter key, redirect to firstItemSearch
            const code = e.keyCode || e.which;
            if(code === 13 && firstItemSearch && text.length > 0) {
                window.location.href = window.location.origin + firstItemSearch.attr('href');
            }
            $('#menu-panels').find('.collapse').each(function() {
                const panel = $(this);
                let visible = false;
                panel.find('.menu-item').each(function() {
                    if(!$(this).parent().is('.hidden')) {
                        visible = true;
                        return false;
                    }
                    return undefined;
                });

                const anchor = $('#menu-panels').find('a[aria-controls="' + panel.attr('id') + '"]');
                anchor.parent().toggleClass('hidden', !visible);
            });
            $('#menu-panels .bg-info').each(function() {
                const bgInfo = $(this);
                const ul = bgInfo.find('.navbar-nav');
                const elements = ul.find('li').not('.hidden');
                bgInfo.toggleClass('only-element', (elements.length === 1));
            });
            try {
                const storage = window.sessionStorage || window.localStorage;
                if(storage) {
                    storage.setItem('menu-panels-search', text);
                }
            } catch(err) { /**/ }
        });

        try {
            const storage = window.sessionStorage || window.localStorage;
            if(storage) {
                const search = storage.getItem('menu-panels-search');
                if(search && (typeof (search) == 'string')) {
                    $('#menu-panels-search').val(search).trigger('change');
                }
            }
        } catch(err) { /**/ }
    }
});


$(document).ready(function() {
    const sidenavTrigger = $('.sidenav-trigger');
    const visualiza = $('#btn-view3');
    const sendSDI = $('#btn-send-sdi2');

    if($('.sidenav').length > 0) {
        sidenavTrigger.show();
        visualiza.show();
        sendSDI.show();
    } else {
        sidenavTrigger.hide();
        visualiza.hide().attr('style', 'display:none !important');
        sendSDI.hide().attr('style', 'display:none !important');
    }
    if(navigator.standalone) {
        $('a').click(function(event) {
            event.preventDefault();
            window.location = $(this).attr('href');
        });
    }
});


//optional handler
$(window).on('scroll', function() {
    if(!('DISPLAY_WIDTHS' in window)) {
        return;
    }
    if(DISPLAY_WIDTHS.user !== DISPLAY_WIDTHS.xl) return;
    const contentBlock = $('.content-block');
    const menuPanels = $('.menu-block');
    const scrollTop = $(window).scrollTop();
    if(scrollTop > 50) {
        contentBlock.css('margin-top', +menuPanels.height() + 20 + 'px');
        menuPanels.addClass('stick');
    } else {
        contentBlock.css('margin-top', '');
        menuPanels.removeClass('stick');
    }
});


// one line menu buttons
let transformedUtente = false;
const oneLineMenu = {
    menu: '',
    menuLi: '',
    h: 70,
    sortedGroups: [],
    menuPanels: [],
    readyHtml: [],
    transformState: false,
    init: function() {
        const self = this;
        //menu is not everywhere
        if(!('__MENU_PANELS__' in window) || !__MENU_PANELS__ || !__MENU_PANELS__.length) {
            return;
        }
        if(__MENU_PANELS__.length > 1) {
            // move after menu loads and if it's a root user ( more than 1 panel )
            $(document).ready(function() {
                self.moveUtenteMenu();
            });
            $(window).on('resize', function() {
                self.moveUtenteMenu();
            });
            return;
        }
        this.menuPanels = __MENU_PANELS__[0];
        const applyMenu = function() {
            self.menu = $('#menu-panels');
            self.menuLi = self.menu.find('li');
            if(!self.menu.length || !self.menuLi.length) return;
            if(!self.transformState) self.transformState = true; else return;
            self.cleanLis();
        };
        $(window).on('resize', applyMenu);
        $(document).ready(applyMenu);
    },
    cleanLis: function() {
        // remove elements starting from list divider and search
        this.menuLi = this.menuLi.splice(1, this.menuLi.length - 2);
        this.sortGroups();
    },
    sortGroups: function() {
        const self = this;
        this.menuLi.forEach(function(elem, index) {
            self.menuPanels.panel.forEach(function(panel) {
                if(panel.label.toLowerCase() == $(elem).text().toLowerCase().trim()) {
                    if(!self.sortedGroups[panel.panel]) {
                        self.sortedGroups[panel.panel] = [];
                        self.sortedGroups[panel.panel].unshift(elem);
                    } else {
                        self.sortedGroups[panel.panel].unshift(elem);
                    }
                }
            });
        });
        this.getHtmlBlocks();
    },
    getHtmlBlocks: function() {
        const self = this;
        let utenteState = true;
        let userName = '';
        try {
            userName = __PRETTY_USER_NAME__ || '';
        } catch(err) { /**/ }

        Object.keys(this.sortedGroups).forEach(function(key) {
            const keyString = key.replace(/ /g, '-');
            if(self.sortedGroups[key].length > 1 || key == 'Utente') {
                self.sortedGroups[key].html = $(
                    '<li class="bg-info ' + keyString.toLowerCase() + '">'
                    + '<a data-toggle="collapse" href="#menu-panel-' + keyString + '" aria-expanded="false" aria-controls="menu-panel-' + keyString + '" class="menu-item parent-menu-item">'
                    + (keyString == 'Utente' ? '<img class="utente-icon" src="/images/icons/accountInfo.png" />' : '')
                    + (keyString == 'Utente' ? '<span>' + xmlescape(userName) + '</span>' : key)
                    + '<img src="/images/icons/arrowDown.svg" alt="">'
                    + '</a>'
                    + '<div class="bg-info-content panel-collapse collapse in" id="menu-panel-' + keyString + '">'
                    + '<ul class="nav navbar-nav"></ul>'
                    + '</div>'
                    + '</li>',
                );
                self.sortedGroups[key].forEach(function(element) {
                    self.sortedGroups[key].html.find('.navbar-nav').prepend(element);
                    if(keyString == 'Utente' && utenteState) {
                        self.sortedGroups[key].html.find('.navbar-nav').append(''
                            + '<li id="menu-item-exit">'
                            + '<a class="menu-item" href="/logout.cmd">'
                            + '<img width="32" height="32" src="/images/icons/exit.png">'
                            + 'Uscita'
                            + '</a>'
                            + '</li>');
                        utenteState = false;
                    }
                });
                self.readyHtml.push(self.sortedGroups[key].html);
            } else {
                self.sortedGroups[key].html = self.sortedGroups[key][0];
            }
            if(!self.sortedGroups.Utente && utenteState) {
                self.sortedGroups.Utente = [];
                self.sortedGroups.Utente.html = $(
                    '<li class="bg-info utente">'
                    + '<a data-toggle="collapse" href="#menu-panel-Utente" aria-expanded="false" aria-controls="menu-panel-Utente" class="menu-item parent-menu-item">'
                    + '<img class="utente-icon" src="/images/icons/accountInfo.png" />'
                    + '<span>' + xmlescape(userName) + '</span>'
                    + '<img src="/images/icons/arrowDown.svg" alt="">'
                    + '</a>'
                    + '<div class="bg-info-content panel-collapse collapse in" id="menu-panel-Utente">'
                    + '<ul class="nav navbar-nav">'
                    + '<li id="menu-item-exit">'
                    + '<a class="menu-item" href="/logout.cmd">'
                    + '<img width="32" height="32" src="/images/icons/exit.png">'
                    + 'Uscita'
                    + '</a>'
                    + '</li>'
                    + '</ul>'
                    + '</div>'
                    + '</li>',
                );
                self.readyHtml.push(self.sortedGroups.Utente.html);
                utenteState = false;
            }
        });
        self.insertHtml();
    },
    insertHtml: function() {
        const self = this;
        this.menu.find('.header-search-form').after(this.readyHtml);
        this.moveUtenteMenu();
        $(window).resize(function() {
            self.moveUtenteMenu();
        });
    },
    moveUtenteMenu: function() {
        const utente = $('.bg-info.utente');
        const w = DISPLAY_WIDTHS.xl;
        if(window.innerWidth < w || screen.width < w) {
            utente.find('#menu-panel-Utente').removeClass('in');
            utente.appendTo('.navbar-header');
            utente.find('a span').prependTo('#menu-panel-Utente ul').wrap("<li class='user_inf'></li>");
            transformedUtente = true;
        } else {
            if(!transformedUtente) return;
            transformedUtente = false;
            utente.find('#menu-panel-Utente').addClass('in');
            utente.appendTo('#menu-panels');
            const text = utente.find('#menu-panel-Utente .user_inf span').unwrap();
            text.insertAfter(utente.find('a img').first());
        }
    },
};
oneLineMenu.init();

// header menu fix for ios safari
$(document).ready(function() {
    try {
        if(window.navigator.platform.match(/iPhone|iPad|iPod/i)) {
            $('#menu-panels').css('max-height', 'calc(100vh - 145px)');
        }
    } catch(e) { /**/ }
});
